import React from 'react'
import { Link } from 'react-router-dom'

function Cookbook() {
  return (
    <div>
      <Link to="/cookbook/terms">
        <div>Terms and Conditions</div>
      </Link>
      <Link to="/cookbook/policy">
        <div>Privacy Policy</div>
      </Link>
    </div>
  )
}

export default Cookbook
